module.exports = __webpack_public_path__ + "static/ringingbells1-02834b49e45b8cbdb57bb12d39188fc5.jpg";